import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AgentOptions, { NONE_OPTION_LABEL } from './AgentOptions';

const MappedAgentSelect = ({
  agents,
  mappedAgentOnChange,
  mappedUserIntegration,
  selectElementId,
}) => {
  const initialAgent = {
    id: mappedUserIntegration.mapped_agent_id || '',
    username: mappedUserIntegration.mapped_username || NONE_OPTION_LABEL,
  };

  const [isActive, setIsActive] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(initialAgent);

  const handleOnChange = async (e) => {
    const { value, selectedOptions } = e.target;
    const { label: username } = selectedOptions[0];

    setSelectedAgent({
      id: value,
      username,
    });

    setIsActive(false);

    const updatedIntegration = {
      ...mappedUserIntegration,
      mapped_agent_id: Number(value) || null,
      mapped_username: username,
    };

    try {
      await mappedAgentOnChange(updatedIntegration);
    } catch {
      setSelectedAgent(initialAgent);
    }
  };

  return (
    <select
      className="mapped-agent-select"
      id={selectElementId}
      onBlur={() => {
        setIsActive(false);
      }}
      onChange={handleOnChange}
      onMouseDown={() => {
        setIsActive(true);
      }}
      value={selectedAgent.id}
    >
      {isActive ? (
        <AgentOptions agents={agents} />
      ) : (
        <option value={selectedAgent.id}>{selectedAgent.username}</option>
      )}
    </select>
  );
};

MappedAgentSelect.propTypes = {
  agents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  mappedAgentOnChange: PropTypes.func,
  mappedUserIntegration: PropTypes.shape({
    mapped_agent_id: PropTypes.number,
    mapped_username: PropTypes.string,
    property_id: PropTypes.number,
    vendor: PropTypes.string,
    vendor_property_id: PropTypes.string,
  }),
  selectElementId: PropTypes.string,
};

export default MappedAgentSelect;
